import { zodResolver } from '@hookform/resolvers/zod';
import { Modal } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DateInputControl, Form, FormSubmit } from '@/core/components';

import { EvaluationDatesSchema } from '../model/EvaluationSchema';

interface EvaluationChangeValidationDatesProps extends FormSubmit<EvaluationDatesSchema> {
  onClose: () => void;
}

export function EvaluationChangeValidationDatesForm(props: EvaluationChangeValidationDatesProps) {
  const { onClose, schema, onCancel, isSubmitting, defaultValues, values, onSubmit } = props;
  const { t } = useTranslation();

  const form = useForm<EvaluationDatesSchema>({
    defaultValues,
    values,
    resolver: zodResolver(schema),
  });

  return (
    <Modal
      opened
      onClose={onClose}
      title={t('evaluation.changeValidationDates.title')}
    >
      <FormProvider {...form}>
        <Form
          onSubmit={form.handleSubmit(onSubmit)}
          onCancel={onCancel}
          title={t('evaluation.changeValidationDates.title')}
          isSubmitting={isSubmitting}
        >
          <DateInputControl
            label={t('evaluation.changeValidationDates.closingDate')}
            name="closingDate"
            isSubmitting={isSubmitting}
            control={form.control}
          />
          <DateInputControl
            label={t('evaluation.changeValidationDates.headOfDisciplineClosingDate')}
            name="headOfDisciplineClosingDate"
            isSubmitting={isSubmitting}
            control={form.control}
          />
          <DateInputControl
            label={t('evaluation.changeValidationDates.headOfDepartmentClosingDate')}
            name="headOfDepartmentClosingDate"
            isSubmitting={isSubmitting}
            control={form.control}
          />
        </Form>
      </FormProvider>
    </Modal>
  );
}
